/**
 * Resolve CJS default export for Vite 8 ESM interop.
 * Handles potential double-wrapping: { default: { default: fn } }
 */
export const resolveDefaultExport = (mod: any): any => {
  const resolved =
    mod && typeof mod === 'object' && 'default' in mod ? mod.default : mod
  return resolved && typeof resolved === 'object' && 'default' in resolved
    ? resolved.default
    : resolved
}
